import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["domRef", "label", "path"];
import React from 'react';
const SvgPath = _ref => {
  let {
      domRef,
      label,
      path
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": !label,
    "aria-label": label,
    ref: domRef,
    role: "img",
    viewBox: "0 0 " + props.width + " " + props.height,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: path,
    fillRule: "evenodd"
  }));
};
export default SvgPath;